const ChevronRight = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.146 17.354a.5.5 0 0 1 0-.708L13.793 12 9.146 7.354a.5.5 0 1 1 .708-.708l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708 0"
      clipRule="evenodd"
    />
  </>
)
export default ChevronRight
